import { render, staticRenderFns } from "./SliderButton.vue?vue&type=template&id=ea83d89e&"
import script from "./SliderButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SliderButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea83d89e')) {
      api.createRecord('ea83d89e', component.options)
    } else {
      api.reload('ea83d89e', component.options)
    }
    module.hot.accept("./SliderButton.vue?vue&type=template&id=ea83d89e&", function () {
      api.rerender('ea83d89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/SliderButton.vue"
export default component.exports